import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Devices from "@/pages/Devices";
import LogViewer from "@/pages/LogViewer";
import Keywords from "@/pages/Keywords";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";
import { Loader2 } from "lucide-react";

function Protected({ children, masterOnly }) {
  const { user, ready, isMaster } = useAuth();
  if (!ready)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0B0F17]">
        <Loader2 className="animate-spin text-[#3B82F6]" size={32} />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (masterOnly && !isMaster) return <Navigate to="/dashboard" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/devices" element={<Devices />} />
        <Route path="/logs" element={<LogViewer />} />
        <Route
          path="/keywords"
          element={
            <Protected masterOnly>
              <Keywords />
            </Protected>
          }
        />
        <Route
          path="/users"
          element={
            <Protected masterOnly>
              <Users />
            </Protected>
          }
        />
        <Route path="/settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
